<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Related {{ utils.getLangTerm('contractors.plural', 'Contractors') }}</span>
    <button
      class="navbar-toggler"
      type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          class="m-1 mr-2"
          type="button"
          color="primary"
          mat-raised-button
          (click)="onManageContractors()"
          *ngIf="canEdit"
          matTooltip="Click this button to add a {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.">
          <fa-icon [icon]="faHardHat"></fa-icon>
          Manage {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
        </button>

        <!-- Selection on this tab only drives Unlink Selected, so the menu and its trigger are
             wrapped together in the edit guard. A mat-menu left outside the guard would still be
             rendered into the CDK overlay. -->
        <ng-container *ngIf="canEdit">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button mat-menu-item (click)="onUnlinkSelected()" [disabled]="!dataSource.selection.hasValue()" *ngIf="canEdit">
              <mat-icon>link_off</mat-icon> Unlink Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" [matTooltip]="'Use this menu to select/deselect Asset ' + utils.getLangTerm('contractors.plural', 'Contractors') + '.'" style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search {{ utils.getLangTerm('contractors.singular', 'Contractor') }} by name or industry."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let contractor">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(contractor.id) : null"
            [checked]="dataSource.selection.isSelected(contractor.id)"
            matTooltip="Toggle select this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.">
          #
        </th>
        <td mat-cell *matCellDef="let contractor">
          {{ contractor.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the name of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.">{{ utils.getLangTerm('contractors.singular', 'Contractor') }}</th>
        <td mat-cell *matCellDef="let contractor" class="text-wrap">
          {{ contractor.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contact_person">
        <th mat-header-cell *matHeaderCellDef>
          Main Contact
        </th>
        <td mat-cell *matCellDef="let contractor">
          <ng-container *ngIf="contractor?.main_contact">
            <p>
              <a (click)="onUserPublicView(contractor.main_contact.hash)"
                 matTooltip="View User Public Profile">
                {{ contractor.main_contact.contact_person }}
              </a> <br>
              {{ contractor.main_contact.email }}<br>
              {{ contractor.main_contact.mobile }}
            </p>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="industry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the industry of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.">Industry</th>
        <td mat-cell *matCellDef="let contractor">
          {{ contractor.industry }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} was enrolled.">
          Date Enrolled
        </th>
        <td mat-cell *matCellDef="let contractor">
          {{ (contractor.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} was enrolled.">
          Date Enrolled (UTC)
        </th>
        <td mat-cell *matCellDef="let contractor">
          {{ (contractor.date_created * 1000) | timezoneConvertUTCMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>
        <td mat-cell *matCellDef="let contractor">
          <button type="button" mat-button (click)="onUnlink(contractor.id)" *ngIf="canEdit">
            Unlink
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>

